import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [
    ];

    connect()
    {
    }

    handleResponse(event)
    {
        if (event.detail[0].success)
		{
			const createEvent = new CustomEvent("show-toast", { detail: "OOS Category successfully changed!" });
			window.dispatchEvent(createEvent);

            setTimeout(() =>
            {
                this.element.previousElementSibling.querySelector(".goback").firstElementChild.click();
            }, 500);
		}
		else
		{
			const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error });
			window.dispatchEvent(errorEvent);
		}
    }

}